import React from "react";
import PropTypes from "prop-types";

import "./DropdownWrapper.scss";

const DropdownWrapper = ({ children, title, isOpen, onClick })=> {
  return (
    <button
      className="dropdown-wrapper"
      onClick={onClick}
    >
      <div className="dropdown-wrapper__title">
        <span className="dropdown-wrapper__title__text">{title}</span>
        <div className={`
          dropdown-wrapper__title__arrow
          dropdown-wrapper__title__arrow--${isOpen ? "open" : "close"}
        `}/>
      </div>
      <div
        onClick={e => e.stopPropagation()}
        className={`
          dropdown-wrapper__children
          dropdown-wrapper__children--${isOpen ? "open" : "close"}
        `}
      >
        {children}
      </div>
    </button>
  );
};

DropdownWrapper.propTypes = {
  children: PropTypes.any,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string
};

DropdownWrapper.defaultProps = {
  children: null,
  isOpen: false,
  onClick: ()=> {},
  title: ""
};

export default DropdownWrapper;
